import styles from './ImageBlock.module.css';

export const ImageBlock = () => (
    <div className={styles.container}>
        <div className={styles.img} />
    </div>
);
